import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={72}
    viewBox="0 0 48 72"
    fill="none"
    {...props}
  >
    <path
      stroke="#D9D9D9"
      strokeMiterlimit={10}
      strokeWidth={2}
      fill="#FFFFFF"
      d="M28.531 49.562s.239 0 .345-.026c.318-.053.637-.16.902-.345 1.513-.956 1.22-2.574 1.646-4.06.212-.717.636-1.327 1.061-1.911 3.078-4.007 7.324-6.82 10.43-10.748a17.952 17.952 0 0 0 3.502-7.218c1.22-5.493.133-10.562-2.813-15.285l-.16-.24c-1.034-1.193-1.99-2.387-3.184-3.449-3.556-3.184-8.359-4.83-13.056-5.175-7.112-.504-13.879.717-19.399 5.52-3.715 3.238-6.448 8.067-6.793 13.056-.08 1.115.239 2.044.982 2.866.477.531 1.088.956 1.804 1.088.24.053.505.053.743.053.266 0 .531.027.823.053h3.874c1.248 0 2.734.107 3.955-.132.583-.106 1.061-.372 1.539-.717 1.326-.955 1.273-2.335 1.83-3.715 1.54-3.688 4.99-4.83 8.731-4.272 1.805.265 3.556 1.194 4.644 2.68 1.062 1.46 1.3 3.556.982 5.28-.504 2.681-2.733 4.804-4.644 6.609l-4.246 4.033c-1.433 1.46-2.866 3.132-3.927 4.883-.027.053-.053.106-.08.133-1.035 2.07-1.618 4.007-1.698 6.342-.027.85-.027 1.805.239 2.627.212.664.584 1.115 1.088 1.566.132.133.318.239.477.318.053.027.133.053.186.08.212.08.425.106.637.106l9.553.053.027-.053ZM23.33 55.53h3.396c1.46 0 2.999-.265 4.113.876.372.372.664.85.797 1.38.265 1.035.132 2.336.132 3.424v5.785c-.053.902-.318 1.698-.982 2.308-.371.345-.822.61-1.327.717-1.247.265-2.945.053-4.219.053-2.096 0-4.326.16-6.422 0-.398-.026-.77-.186-1.141-.318l-.53-.425c-.611-.584-.903-1.247-.93-2.096v-6.157c.027-1.008-.106-2.309.133-3.29.133-.505.425-.983.796-1.328.982-.981 2.097-.875 3.397-.902h2.786v-.026Z"
    />
  </svg>
)
export default SvgComponent
